import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { IchAppContract } from "./IchAppContract";
import { IchAppSuccess } from "./IchAppSuccess";
import { IchAppEmailVerification } from "./IchAppEmailVerification";
import { IchAppRegistration } from "./IchAppRegistration";
import { IchAppRoutes } from "./IchAppRoutes";
import { IchAppStore } from "./IchAppStore";
import { PdfViewer } from "components/common/PdfViewer";
import { IchAppSigning } from "./IchAppSigning";
import { IchAppDeregistration } from "./IchAppDeregistration";
import { LandingPage } from "components/common/LandingPage";
import { IchAppDeregistrationSuccess } from "./IchAppDeregistrationSuccess";
import { IchAppDeregistrationSigning } from "./IchAppDeregistrationSigning";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class IchAppContainer extends React.Component<IProps> {
    store: IchAppStore;

    constructor(props: any) {
        super(props);
        this.store = new IchAppStore();
    }

    async componentDidMount() {
        pushRoute(IchAppRoutes.ROOT);

        try {
            await this.store.loadData();
        } catch (error) {
            debug.log("### IchAppContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("ichApp.document.title");
        return (
            <div>
                <Route
                    exact
                    path={IchAppRoutes.ROOT}
                    render={() =>
                        <LandingPage
                            useWebVersion
                            type="PRODUCT"
                            code="ICHAPP"
                            store={this.store}
                            onClickButton={async () => {
                                // await trackingStore.trackEvent({ eventName: "orderNow" });
                                if (this.store.status?.status === "REGISTERED") {
                                    pushRoute(IchAppRoutes.DEREGISTRATION);
                                } else {
                                    pushRoute(IchAppRoutes.REGISTRATION);
                                }
                            }}
                        />
                    }
                />
                <Route exact path={IchAppRoutes.REGISTRATION} component={this.withStore(IchAppRegistration)} />
                <Route exact path={IchAppRoutes.EMAIL_VERIFICATION} component={this.withStore(IchAppEmailVerification)} />
                <Route exact path={IchAppRoutes.CONTRACT} component={this.withStore(IchAppContract)} />
                <Route exact path={IchAppRoutes.SIGNING} component={this.withStore(IchAppSigning)} />
                <Route exact path={IchAppRoutes.SUCCESS} component={this.withStore(IchAppSuccess)} />
                <Route exact path={IchAppRoutes.DEREGISTRATION} component={this.withStore(IchAppDeregistration)} />
                <Route exact path={IchAppRoutes.DEREGISTRATION_SIGNING} component={this.withStore(IchAppDeregistrationSigning)} />
                <Route exact path={IchAppRoutes.DEREGISTRATION_SUCCESS} component={this.withStore(IchAppDeregistrationSuccess)} />
                <Route path={IchAppRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppContainer.tsx